import script from "./Anonymous.vue?vue&type=script&setup=true&lang=js"
export * from "./Anonymous.vue?vue&type=script&setup=true&lang=js"

import "./Anonymous.vue?vue&type=style&index=0&id=de574662&lang=scss"

const __exports__ = script;

export default __exports__